import styled from "styled-components"
import theme from "styles/theme-main"
import Text from "components/Text"

export const ConfirmationWrapper = styled.div`
  width: 752px;
  max-width: 100%;
  border: solid 1px ${theme.colors.border};
  background-color: ${theme.colors.light};
  margin: 90px auto 0 auto;

  @media (max-width: 800px) {
    margin: -30px auto 0 auto;
  }
`

export const ConfirmationContent = styled.div`
  width: 100%;
  margin: 38px 30px 62px 30px;
`

export const IconCont = styled.div`
  width: 40px;
  height: 40px;
  display: inline-block;
  margin-right: 12px;
`

export const ModalTitle = styled(Text)`
  margin: 0 0 30px 0;
  text-transform: uppercase;
  letter-spacing: 5px;
  display: flex;
  justify-content: flex start;
  align-content: center;
  max-width: 100%;
`

export const InformationContainer = styled.div`
  margin: 31px 0 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
`

export const InfomationRow = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-content: center;
`

export const InformationLabel = styled.div`
  width: 117px;
`

export const InformationData = styled.div`
  font-weight: bold;
`

export const ButtonWrapper = styled.div`
  max-width: 100%;
  margin: 10px 0 0 0;
`

export const EventWrapper = styled.div`
  width: 1143px;
  border: solid 1px ${theme.colors.border};
  background-color: ${theme.colors.light};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 90px auto 0 auto;

  @media (max-width: 800px) {
    margin: -21px auto -50px auto;
    max-width: 100%;
    flex-direction: column;
  }
`

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 800px;
  max-width: 100%;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 343px;
  max-width: 100%;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const EventImage = styled.div`
  width: 800px;
  height: 400px;
  overflow: hidden;
  background-color: ${props => props.bgColor};

  @media (max-width: 800px) {
    max-width: 100%;
    height: max-content;
  }

  & > img {
    max-width: 100%;
  }
`

export const EventDetails = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;

  @media (max-width: 800px) {
    display: none;
  }
`

export const EventDetailsMobile = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;

  @media (min-width: 800px) {
    display: none;
  }
`

export const EventDetialsWrapper = styled.div`
  margin: 55px 115px 55px 115px;
  width: 100%;

  @media (max-width: 800px) {
    margin: 22px 20px 22px 20px;
  }
`

export const EventTitle = styled.div`
  height: 400px;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  justify-content: flex-start;

  @media (max-width: 800px) {
    height: max-content;
  }
`

export const EventTitleWrapper = styled.div`
  margin: 40px 32px 30px 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: space-between;

  @media (max-width: 800px) {
    margin: 22px 20px 22px 20px;
    height: max-content;
  }
`

export const EventInfomation = styled.div`
  background-color: #efefef;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-content: center;
`

export const EventInformationWrapper = styled.div`
  margin: 60px 32px 60px 32px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;

  @media (max-width: 800px) {
    margin: 22px 20px 22px 20px;
  }
`

export const InformationCont = styled.div`
  margin-bottom: 32px;

  @media (max-width: 800px) {
    margin-bottom: 25px;
  }
`

export const EventInformationLabel = styled.div`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: bold;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: ${theme.colors.textPrimary};
`

export const EventInformationData = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: ${theme.colors.textPrimary};
`

export const H2 = styled.div`
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 5px;
  color: ${theme.colors.textSecondaryDark};

  @media (max-width: 800px) {
    font-size: 20px;
  }
`

export const H3 = styled.div`
  font-size: 21px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: normal;
  color: ${theme.colors.textPrimary};
  margin-bottom: 24px;

  @media (max-width: 800px) {
    font-size: 18px;
  }
`

export const P = styled.div`
  @media (max-width: 800px) {
    font-size: 16px;
  }
`

export const Link = styled.a`
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 2px;
  color: ${theme.colors.textSecondary};
  padding-bottom: 5px;
  border-bottom: 2px dotted ${theme.colors.textSecondary};
  text-decoration: none;
  text-transform: uppercase;
  word-break: break-all;
`

export const RegisterButtonForDesktop = styled.div`
  display: none;

  @media (min-width: 800px) {
    display: block;
  }
`

export const RegisterButtonForMobile = styled.div`
  display: none;
  padding: 9px 20px 9px 20px;
  border-top: 1px solid ${theme.colors.border};

  @media (max-width: 800px) {
    display: block;
  }
`
